import { motion } from "framer-motion";
import { ArrowUpRight, Calendar, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import blogs from "../../data/blogs.json";

function formatDate(dateStr) {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}

export default function Insights() {
    const items = blogs.slice(0, 3);

    return (
        <section
            id="insights"
            data-testid="insights-section"
            className="relative bg-white py-24 lg:py-32"
        >
            <div className="mx-auto max-w-[1440px] px-6 lg:px-10">
                <div className="grid lg:grid-cols-12 gap-10 items-end pb-16">
                    <div className="lg:col-span-4">
                        <p className="label-eyebrow">Articles</p>
                        <motion.h2
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.9 }}
                            className="mt-4 font-display text-2xl sm:text-3xl lg:text-4xl tracking-tight text-communiti-text leading-[0.95]"
                        >
                            <span className="block font-bold uppercase text-communiti">
                                OUR BLOGS
                            </span>
                        </motion.h2>
                    </div>
                    <div className="lg:col-span-8 lg:justify-self-end">
                        <p className="max-w-md text-sm text-communiti-muted leading-relaxed">
                            Discover actionable digital marketing, business, and growth insights from the best digital marketing agency in Indore.
                        </p>
                    </div>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                    {items.map((blog, i) => (
                        <motion.article
                            key={blog.id}
                            data-testid={`blog-card-${blog.id}`}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, amount: 0.3 }}
                            transition={{
                                duration: 0.8,
                                delay: i * 0.08,
                                ease: [0.16, 1, 0.3, 1],
                            }}
                            className="group flex flex-col rounded-2xl border border-communiti-line bg-white overflow-hidden hover:border-communiti hover:-translate-y-1 transition-all duration-500"
                        >
                            <Link to={`/blog/${blog.id}`} className="flex flex-col flex-1">
                                <div className="relative aspect-[16/10] overflow-hidden bg-communiti-surface">
                                    <img
                                        src={blog.featured_image}
                                        alt={blog.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                                    />
                                </div>
                                <div className="flex flex-1 flex-col p-6 sm:p-7">
                                    <div className="flex flex-wrap items-center gap-3 text-[11px] uppercase tracking-[0.18em] text-communiti-muted">
                                        <span className="inline-flex items-center gap-1.5">
                                            <span className="h-1.5 w-1.5 rounded-full bg-communiti" />
                                            {blog.category}
                                        </span>
                                        <span className="inline-flex items-center gap-1">
                                            <Calendar className="h-3.5 w-3.5" />
                                            {formatDate(blog.date)}
                                        </span>
                                        <span className="inline-flex items-center gap-1">
                                            <Clock className="h-3.5 w-3.5" />
                                            {blog.read_time}
                                        </span>
                                    </div>

                                    <h2 className="mt-5 font-display text-xl sm:text-2xl tracking-tight text-communiti-text leading-[1.05]">
                                        {blog.title}
                                    </h2>

                                    <p className="mt-3 text-sm text-communiti-muted leading-relaxed line-clamp-3 flex-1">
                                        {blog.excerpt}
                                    </p>

                                    <div className="mt-6 flex items-center justify-between pt-5 border-t border-communiti-line">
                                        <span className="text-[11px] uppercase tracking-[0.18em] text-communiti-muted">
                                            {blog.author}
                                        </span>
                                        <span className="inline-flex h-9 w-9 items-center justify-center rounded-full bg-communiti-surface text-communiti-text group-hover:bg-communiti group-hover:text-white transition-all duration-300">
                                            <ArrowUpRight className="h-4 w-4" />
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        </motion.article>
                    ))}
                </div>

                <div className="mt-12 text-center">
                    <Link
                        to="/blog"
                        className="inline-flex items-center gap-2 rounded-full bg-communiti px-6 py-3 text-sm font-medium text-white hover:bg-communiti-soft transition-colors"
                    >
                        View all articles
                        <ArrowUpRight className="h-4 w-4" />
                    </Link>
                </div>
            </div>
        </section>
    );
}
